import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend";
// import LocizeBackend from 'i18next-locize-backend'
import { initReactI18next } from "react-i18next/initReactI18next";
import {
  fallbackLng,
  languages,
  defaultNS,
  Lang,
  cookieName,
} from "./settings";

const runsOnServerSide = typeof window === "undefined";

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(
    resourcesToBackend(
      (language: Lang, namespace: string) =>
        import(`./locales/${language}/${namespace}.json`)
    )
  )
  // .use(runsOnServerSide ? LocizeBackend : resourcesToBackend((language, namespace) => import(`./locales/${language}/${namespace}.json`))) // locize backend could be used, but prefer to keep it in sync with server side
  .init({
    //debug: true,
    saveMissing: true,
    supportedLngs: languages,
    fallbackLng,
    lng: undefined, // let detect the language on client side
    fallbackNS: defaultNS,
    defaultNS,
    detection: {
      order: ["cookie", "path"],
      lookupCookie: cookieName,
    },
    interpolation: {
      // React already escapes rendered text; keep interpolation readable.
      escapeValue: false,
    },

    preload: runsOnServerSide ? languages : [],
    //resources,
  });

export default i18next;
